<template>
    <router-view/>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "CreativePreview",
  methods: {
  },
  created() {}
};
</script>